import { createContext } from 'react'
import { SurveyState, initialState, SurveyMode } from '@reducers/SurveyReducer'
import { AnswerObject, AnswerType } from '@models/Survey/Answer'
import { SurveyStep } from '@models/Survey/SurveyStep'
import { QuestionnairePhase } from '@utils/categoryFlow'

export interface SurveyContextProps extends SurveyState {
  fetchSurvey: (surveyId: string) => Promise<void>
  setPreviousQuestion(): void
  setNextQuestion(): void
  setQuestion(slug: string): void
  setAnswer(answer: AnswerType): void
  setAcknowledge(acknowledged: boolean): void
  setMode(mode: SurveyMode): void
  submitAnswers: () => Promise<void>
  submitEmail: (email: string) => Promise<void>
  submitSandbox: () => Promise<void>
  submitCompleteSurvey: () => Promise<void>
  resetSandbox: (answers: AnswerObject) => Promise<void>
  setAnswerObject(answerObject: AnswerObject): void
  setNextStep(nextStep: SurveyStep): void
  setIsEnabled(status: boolean): void
  setSurveyStartedAt(startedAt: string): void
  autofillSurvey(): void
  continueToSecondQuestionnaire: () => Promise<void>
  switchSandboxSurvey: (surveyKey: string) => Promise<void>
  setResultVariant(variant: 'intermediate' | 'final' | undefined): void
  setQuestionnairePhase(phase: QuestionnairePhase): void
  setEmail(email: string): void
  setPortraitForSurvey(surveyKey: string, dataUrl: string): void
  setResultsSnapshot(surveyKey: string, snapshot: unknown): void
}

export const initialSurveyContext: SurveyContextProps = {
  ...initialState,
  fetchSurvey: () => new Promise(() => { }),
  setPreviousQuestion: () => { },
  setNextQuestion: () => { },
  setQuestion: () => { },
  setAnswer: () => { },
  setAcknowledge: () => { },
  setMode: () => { },
  submitAnswers: () => new Promise(() => { }),
  submitEmail: () => new Promise(() => { }),
  submitSandbox: () => new Promise(() => { }),
  submitCompleteSurvey: () => new Promise(() => { }),
  resetSandbox: () => new Promise(() => { }),
  setAnswerObject: () => () => { },
  setNextStep: () => { },
  setIsEnabled: () => { },
  setSurveyStartedAt: () => { },
  autofillSurvey: () => { },
  continueToSecondQuestionnaire: () => new Promise(() => { }),
  switchSandboxSurvey: () => new Promise(() => { }),
  setResultVariant: () => { },
  setQuestionnairePhase: () => { },
  setEmail: () => { },
  setPortraitForSurvey: () => { },
  setResultsSnapshot: () => { },
}

export const SurveyContext = createContext<SurveyContextProps>(initialSurveyContext)
